import {getDataWithPromise, Globals, handleAjaxError } from "./BaseDataFns";

export const getPPPlusYearsForChild = ( child_id, onComplete ) =>
{
    const url = Globals.APIFolder + '/children/' + child_id + '/ppplus/years' ;

    getDataWithPromise ( url, 'GET', {} )
    .then (response =>
    {
        onComplete (response) ;
    })
    .catch( (jqXHR, textStatus, error) =>
    {
        handleAjaxError( jqXHR, textStatus, error) ;
    });
}

export const getChildPPPlusForYear = ( child_id, year_id, onComplete ) =>
{
    const url = Globals.APIFolder + '/children/' + child_id + '/ppplus/' + year_id ;

    getDataWithPromise ( url, 'GET', {} )
    .then (response =>
    {
        onComplete (response) ;
    })
    .catch( (jqXHR, textStatus, error) =>
    {
        handleAjaxError( jqXHR, textStatus, error) ;
    });
}

export const updatePPPlusForChild = ( reviewData, onComplete ) =>
{
    const data = { ppplus_data: reviewData } ;

    const url = Globals.APIFolder + '/children/' + reviewData.child_id + '/ppplus' ;

    getDataWithPromise ( url, 'PUT', data )
    .then (response =>
    {
        onComplete (response) ;
    })
    .catch( (jqXHR, textStatus, error) =>
    {
        handleAjaxError( jqXHR, textStatus, error) ;
    });
}
